import { Tabs } from '@mantine/core';
import { useLocation, useNavigate } from 'react-router';

const TABS = [
  { label: 'Quality Formulas', value: '/quality-formulas' },
  { label: 'Template Manager', value: '/templates' },
];

/**
 * Top-of-page switcher between the two Quality Adjustment experiences:
 * - Quality Formulas (`/quality-formulas`) — enter/test quality-adjustment values for one contract.
 * - Template Manager (`/templates`) — create, edit, and test the reusable Templates that
 *   Quality Formulas' "Load Template" can pull from.
 *
 * This is a lightweight, page-level control rather than global chrome — this app's shared
 * host `Layout` (see services/ui/src/layouts) governs the embedded iframe's SLDS wrapper, not
 * in-app navigation, so each of the two pages renders this directly instead of introducing a
 * new shell-level nav.
 */
export const QualityAdjustmentsNav: React.FC = () => {
  const location = useLocation();
  const navigate = useNavigate();
  // Both `/templates/new` and `/templates/:id/edit` are still "in" the Template Manager
  // experience, so any path under `/templates` keeps that tab highlighted.
  const activeTab = location.pathname.startsWith('/templates') ? '/templates' : '/quality-formulas';

  return (
    <Tabs
      onChange={value => {
        if (value) void navigate(value);
      }}
      value={activeTab}
    >
      <Tabs.List>
        {TABS.map(tab => (
          <Tabs.Tab key={tab.value} value={tab.value}>
            {tab.label}
          </Tabs.Tab>
        ))}
      </Tabs.List>
    </Tabs>
  );
};
